import { Classification, Frequency } from "@shared/enums";
import { LABELS } from './labels.constant';

export const FREQUENCY_OPTIONS = [
	{ label: 'Monthly', value: Frequency.MONTHLY },
	{ label: 'Semi-Monthly', value: Frequency.SEMI_MONTHLY }
];

export const ANNUAL_FREQUENCY_OPTIONS = [
	{ label: 'Annual', value: Frequency.ANNUAL },
];

export const FREQUENCY_OPTIONS2 = [
	{ label: 'Monthly', value: Frequency.MONTHLY },
	{ label: 'Semi-Monthly', value: Frequency.SEMI_MONTHLY },
	{ label: 'Quarterly', value: Frequency.QUARTERLY },
	{ label: 'Annual', value: Frequency.ANNUAL }
];

export const WITHHOLDING_FREQUENCY_OPTIONS = [
	{ label: 'Daily', value: Frequency.DAILY },
	{ label: 'Weekly', value: Frequency.WEEKLY },
	{ label: 'Semi-Monthly', value: Frequency.SEMI_MONTHLY },
	{ label: 'Monthly', value: Frequency.MONTHLY },
];

export const ADJUSTMENT_OPTIONS = [
	{ label: 'Yes', value: true },
	{ label: 'No', value: false }
];

export const YES_OR_NO = [
	{ label: 'Yes', value: true },
	{ label: 'No', value: false }
];

export const CTPA_FREQUENCY_OPTIONS = [
	{ label: 'Daily', value: Frequency.DAILY },
	{ label: 'Weekly', value: Frequency.WEEKLY },
	{ label: 'Monthly', value: Frequency.MONTHLY },
	{ label: 'Semi-Monthly', value: Frequency.SEMI_MONTHLY },
	{ label: 'Quarterly', value: Frequency.QUARTERLY },
	{ label: 'Annual', value: Frequency.ANNUAL }
];

export const FrequencyLabels: Record<string, string> = {
	[Frequency.DAILY]: LABELS.DAILY,
	[Frequency.ANNUAL]: LABELS.ANNUAL,
	[Frequency.MONTHLY]: LABELS.MONTHLY,
	[Frequency.QUARTERLY]: LABELS.QUARTERLY,
	[Frequency.SEMI_MONTHLY]: LABELS.SEMI_MONTHLY,
	[Frequency.WEEKLY]: LABELS.WEEKLY,
}

export const ClassificationOptions: Record<Classification, string> = {
	[Classification.AMOUNT]: LABELS.AMOUNT,
	[Classification.PERCENT]: LABELS.PERCENT
};

export const ClassificationAmotPctOptions = [
	{ label: 'Percent',  value: true },
	{ label: 'Amount', value: false }
];

export const WITHHOLDING_TAX_FREQ_COUNT: Record<string, number> = {
	[Frequency.DAILY]: 365,
	[Frequency.MONTHLY]: 12,
	[Frequency.SEMI_MONTHLY]: 24,
	[Frequency.WEEKLY]: 52,
}